module.exports = __webpack_public_path__ + "static/media/Logout.0c70c81a.svg";